import { render } from "./login.vue?vue&type=template&id=2a36ac6f&ts=true"
import script from "./login.vue?vue&type=script&lang=ts&config=true"
export * from "./login.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__